import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CandidateMandatesComponent } from "./candidate-mandates.component";
import { TranslateModule } from "@ngx-translate/core";
import { TableModule } from '@valg-shared/components/table/table.module';
import { ResultSummaryModule } from '@shared/components/result-summary/result-summary.module';
import { ValgMessageBarModule } from "@valg-shared/components/valg-message-bar/valg-message-bar.module";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        TableModule,
        ResultSummaryModule,
        ValgMessageBarModule
    ],
  declarations: [
    CandidateMandatesComponent
  ],
  exports: [
    CandidateMandatesComponent
  ]
})
export class CandidateMandatesModule {}
